export const PAYMENT_METHODS_ROUTE_PATHS = {
  paymentMethods: '/payment-methods',
  paymentMethodDetail: '/payment-methods/$methodCountryId',
  paymentMethodRules: '/payment-methods/$methodCountryId/rules',
};

export const PAYMENT_METHODS_API_PATHS = {
  list: '/v1/api/platform/payment-methods',
  byId: (id: number | string) => `/v1/api/platform/payment-methods/${id}`,
  pmCombo: '/v1/api/platform/payment-methods/pm-combo',
  categories: '/v1/api/platform/payment-methods/categories',
  gateways: '/v1/api/platform/payment-methods/gateways',
  templates: '/v1/api/platform/payment-methods/templates',
  nativeView: '/v1/api/platform/payment-methods/native-view',
  countries: '/v1/api/platform/users/countries',
  currencies: '/v1/api/platform/common-services/all/currencies',
  methodCountry: (id: number | string) => `/v1/api/platform/payment-methods/method-country/${id}`,
  createMethodCountry: '/v1/api/platform/payment-methods/method-country',
  bulkStatus: '/v1/api/platform/payment-methods/massive-method-country',
  uploadSvg: '/v1/api/platform/payment-methods/upload-file-svg',
  // create-time logo upload: no methodCountry exists yet → generic /file (multipart: file, name)
  uploadFile: '/v1/api/platform/payment-methods/file',
  files: (methodCountryId: number | string) =>
    `/v1/api/platform/payment-methods/file/${methodCountryId}`,
  fileById: (id: number | string) => `/v1/api/platform/payment-methods/file/${id}`,
  routes: '/v1/api/platform/payment-methods/routes',
  batchRouteGenerate: '/v1/api/platform/payment-methods/batch-massive-route-generate',
  routingRules: '/v1/api/platform/payment-methods/routing-rules',
  routingRule: '/v1/api/platform/payment-methods/routing-rule',
  validationRules: (country: string, code: string) =>
    `/v1/api/platform/payment-methods/validation-rules/${country}/${code}`,
  validationRule: '/v1/api/platform/payment-methods/validation-rule',
  merchantRule: '/v1/api/platform/payment-methods/merchant-rule',
  statusText: '/v1/api/platform/payment-methods/method-status-text',
  // Withdrawal-methods status text endpoints stay on /public/ until the WM ticket migrates them.
  statusTextMode: '/public/v1/api/wm/method-status-text/mode',
  statusTextLanguages: '/public/v1/api/wm/method-status-text/languages',
};

export const PM_QUERY_KEYS = {
  list: 'pm:list',
  combo: 'pm:combo',
  categories: 'pm:categories',
  countries: 'pm:countries',
  gateways: 'pm:gateways',
  templates: 'pm:templates',
  nativeView: 'pm:native-view',
  currencies: 'pm:currencies',
  detail: 'pm:detail',
  logos: 'pm:logos',
  routes: 'pm:routes',
  routingRules: 'pm:routing-rules',
  validationRules: 'pm:validation-rules',
  merchantRule: 'pm:merchant-rule',
  statusText: 'pm:status-text',
  statusTextMode: 'pm:status-text-mode',
  statusTextLanguages: 'pm:status-text-languages',
} as const;

export const PM_STATUS = ['ACTIVE', 'INACTIVE', 'TESTING', 'OUT_OF_SERVICE'] as const;
export type PmStatus = (typeof PM_STATUS)[number];

export const ROUTE_STATUS = ['ACTIVE', 'INACTIVE', 'AUTO_OFF', 'TESTING'] as const;
export type RouteStatus = (typeof ROUTE_STATUS)[number];

export const RULE_STATUS = ['ACTIVE', 'INACTIVE', 'LOGGER'] as const;
export type RuleStatus = (typeof RULE_STATUS)[number];

export const PM_SCOPE = 'payment-methods';
